<template>
  <div class="push-log">
    <div class="status-body">
      <div class="filter-condition">
        <div class="box-left">
          <div class="left_top">
            <span>计划推送时间:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-select
                v-model="queryParams.ruleType"
                placeholder="请选择推送时间"
                @change="onSubmit()"
                clearable
              >
                <el-option
                  v-for="item in typelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <span style="margin-left: 10px">实际推送时间:</span>
            <div class="filterHospitalTitle" style="display: inline-block">
              <el-date-picker
                v-model="pushDate"
                type="date"
                placeholder="选择日期"
                @change="onSubmit()"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格区域 -->
      <div class="table-conter">
        <!-- 列表 -->
        <div class="table-list">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            stripe
            :header-cell-style="{
              background: '#fff',
              color: '#303133',
              fontWeight: '100',
              height: '60px',
            }"
          >
            <template slot="empty">
              <div class="table-noData">
                <img
                  class="table-noData-img"
                  src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
                />
                <div class="table-noData-word">暂无相关内容</div>
              </div>
            </template>
            <el-table-column prop="pushTitle" label="推送内容" min-width="20%"></el-table-column>
            <el-table-column label="推送名单" min-width="20%">
              <template slot-scope="scope">
                <div style="display: flex">
                  <span class="peopleNumbers">{{ scope.row.pushNum }}人</span>
                  <el-button
                    type="text"
                    style="font-size: 16px; margin-left: 10px"
                    @click="checkDetails(scope.row)"
                  >
                    查看详情
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="计划推送时间" min-width="20%">
              <template slot-scope="scope">
                <span>入职第{{ scope.row.ruleType }}天</span>
              </template>
            </el-table-column>
            <el-table-column prop="pushDate" label="实际推送时间" min-width="20%"></el-table-column>
            <el-table-column label="推送状态" min-width="20%">
              <template slot-scope="scope">
                <div style="display: flex">
                  <div class="pushSuccess" v-if="scope.row.state === 1">推送成功</div>
                  <div class="pushError" v-else>
                    <span>推送失败</span>
                    <el-button
                      type="text"
                      @click="pushAgain(scope.row.id)"
                      style="font-size: 16px; margin-left: 10px"
                    >
                      重新推送
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.page_index"
            :page-size="queryParams.page_size"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalVal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <Dialog
      title="推送日志名单详情"
      :visible="guidelinesVisible"
      width="600px"
      :show-dialog-footer="false"
      @handleClose="guidelinesCloseDialog"
    >
      <template slot>
        <nameList :name="sheetName" :typeval="typeVal" :parameter="parameterObj" ref="nameList" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Dialog from '../../../../components/dialog/index';
import nameList from '../../component/nameList/index';
import { mapGetters } from 'vuex';

import { QueryPushOfLog, HZRePushArticle } from '../../../../api/pointsRule';
export default {
  name: 'PushLog',
  components: { Dialog, nameList },
  data() {
    return {
      typeVal: true,
      sheetName: '',
      queryParams: {
        page_index: 1, // 当前页数
        page_size: 10, // 每页条数
        ruleType: '', // 规则类型
        startTime: '', // 开始时间
        endTime: '', // 结束时间
      }, // 列表接口请求参数
      pushDate: '', // 实际推送时间
      tableData: [], // 表格数据
      totalVal: 1, // 数据总条数
      parameterObj: {}, // 查看详情请求参数
      guidelinesVisible: false, // 名单详情弹窗
      tableLoading: false, // 是否展示加载状态
    };
  },
  computed: {
    ...mapGetters('huizhi/user', {
      typelist: 'getTypeList',
    }),
  },
  created() {
    this.getList();
  },
  methods: {
    onSubmit() {
      this.queryParams.page_index = 1;
      if (this.pushDate) {
        // 日期改变
        const startTime = `${this.pushDate}` + ` 00:00:00`;
        const endTime = `${this.pushDate}` + ` 23:59:59`;
        this.queryParams.startTime = startTime;
        this.queryParams.endTime = endTime;
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.getList();
    },
    // 页码改变
    handleCurrentChange(page) {
      this.queryParams.page_index = page;
      this.getList();
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.page_index = 1;
      this.queryParams.page_size = val;
      this.getList();
    },
    // 获取列表信息
    getList() {
      QueryPushOfLog(this.queryParams)
        .then((res) => {
          const data = res?.pushOfLog;
          this.tableData = data;
          this.totalVal = res.total_num;
          this.tableLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.tableLoading = false;
        });
    },
    // 查看详情
    checkDetails(row) {
      const parmas = {
        ruleId: row.id,
        pushDate: row?.pushDate.substring(0, 10) || '',
      };
      this.parameterObj = parmas;
      this.sheetName = row.pushTitle;
      this.guidelinesVisible = true;
    },
    // 推送日志名单详情弹窗关闭
    guidelinesCloseDialog() {
      this.guidelinesVisible = false;
      this.sheetName = '';
      this.$refs.nameList.resetParameters();
    },
    // 重新推送
    pushAgain(id) {
      HZRePushArticle({ id })
        .then((res) => {
          if (res.err_code === 1) {
            this.$message({
              message: '推送成功',
              type: 'success',
            });
            this.onSubmit();
          } else {
            this.$message({
              message: res.err_msg,
              type: 'error',
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
